import createClient from '../../apolloClient';
import MUTATION_REFRESH_TOKEN from '../../mutation/refreshToken';

const handleRefreshToken = async () => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_REFRESH_TOKEN,
  });
  const { refreshToken } = result?.data || {};
  return refreshToken;
};

export default handleRefreshToken;
